<template>
    <div class="container">
        <img 
            :src="imgUrl"
            alt="升级"
            class="update-img"
        />
        <sob-button
            type="info"
            v-clipboard:error="onError"
            v-clipboard:copy="downLink"
            v-clipboard:success="onSuccess"
            class="down-btn"
        >复制下载链接</sob-button>
        <div class="desc">
            <span>下载安装步骤：</span>
            <span>1.点击“复制下载链接”；</span>
            <span>2.粘贴链接至浏览器；</span>
            <span>3.点击“安装”。</span>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import VueClipboard  from 'vue-clipboard2';
Vue.use(VueClipboard);

export default {
    data() {
        return {
            type: 'super',
        };
    },
    computed: {
        imgUrl() {
            const urls = {
                super: 'https://assets.souche.com/assets/sccimg/yizhihuan/h5/2.5.3-super.png',
                guangqi: 'https://assets.souche.com/assets/sccimg/yizhihuan/h5/2.5.3-gq.png',
                jili: 'https://assets.souche.com/assets/sccimg/yizhihuan/h5/2.5.3-jili.png'
            };
            return urls[this.type] || urls.super;
        },
        downLink() {
            const links = {
                super: 'https://reiko.souche.com/download/com.souche.app.yizhihuan5',
                guangqi: 'https://reiko.souche-inc.com/download/com.souche.app.guangqi?channel=platform',
                jili: 'https://reiko.souche-inc.com/download/com.souche.app.yizhihuan.jili?channel=platform'
            };
            return links[this.type] || links.super;
        }
    },
    methods: {
        onSuccess(){
            this.$som.toast.show({
                text: '已复制到剪切板',
                type: 'success',
                time: 1500
            });
        },
        // 复制失败
        onError(){
            this.$som.toast.show({
                text: '复制失败',
                type: 'error',
                time: 1500
            });
        },
    },
    created() {
        this.type = this.$route.query.type;
    }
};
</script>

<style scoped>
.container {
    box-sizing: border-box;
    width: 100%;
    padding-top: .5rem;
}
.update-img {
    width: 100%;
}
.down-btn {
    width: 1.6rem;
    margin: .1rem auto .2rem;
}
.desc {
    margin: 0 auto;
    color: #8D8E99;
    font-size: .14rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: .21rem;
}
.desc span {
    min-width: 1.6rem;
}
</style>


// WEBPACK FOOTER //
// src/components/download/index.vue